import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { services } from '../../data/servicesData';
import * as S from './Services.styles';

const Services: React.FC = () => {
  return (
    <S.ServicesSection id="servicios">
      <S.Container>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <S.SectionTitle as="h2">Mis Servicios</S.SectionTitle>
          <S.SectionSubtitle>
            Atención médica integral y personalizada para tu bienestar
          </S.SectionSubtitle>
        </motion.div>

        <S.ServicesGrid>
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <S.ServiceCard as={Link} to={`/servicios/${service.slug}`}>
                <S.ServiceIcon>
                  {service.icon}
                </S.ServiceIcon>
                <S.ServiceTitle as="h3">{service.title}</S.ServiceTitle>
                <S.ServiceDescription>
                  {service.description}
                </S.ServiceDescription>
              </S.ServiceCard>
            </motion.div>
          ))}
        </S.ServicesGrid>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <S.CTASection>
            <S.CTATitle as="h3">
              ¿Necesitas atención médica personalizada?
            </S.CTATitle>
            <S.CTADescription>
              Agenda tu consulta y descubre cómo puedo ayudarte a mejorar tu salud 
              con un enfoque integral y humanizado.
            </S.CTADescription>
            <S.CTAButton onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}>
              Agendar Consulta
            </S.CTAButton>
          </S.CTASection>
        </motion.div>
      </S.Container>
    </S.ServicesSection>
  );
};

export default Services;